// import React, { useState } from "react";
// import { Droppable, Draggable } from "@hello-pangea/dnd";
// import {
//   FiTrash2,
//   FiChevronDown,
//   FiMove,
//   FiFile,
//   FiType,
// } from "react-icons/fi";
// import { AiFillStar, AiOutlineStar } from "react-icons/ai";

// interface QuestionContent {
//   id: number;
//   priority: number;
//   title: string;
// }

// interface Question {
//   id: number;
//   title: string;
//   isActive: boolean;
//   questionContentList: QuestionContent[];
//   selectReplyType: { id: number; text: string };
//   questionType: { id: number; text: string };
//   questionAssessmentMethod: { id: number; text: string };
//   validFrom: any;
//   validTo: any;
//   createdDate: any;
//   modifiedDate: any;
//   creator: string | null;
//   modifier: string;
// }

// interface DependencyState {
//   parentQuestionId: number;
//   contentId: number[];
//   isRequired: boolean;
//   // فقط وقتی سوال والد از نوع «درجه‌بندی» (ستاره‌ای) باشد استفاده می‌شود
//   selectedPoint?: number;
// }

// interface Props {
//   selectedQuestions: Question[];
//   dependencyState: Record<number, DependencyState>;
//   onDependencyChange: (
//     questionId: number,
//     parentQuestionId: number,
//     contentId: number[],
//     selectedPoint?: number
//   ) => void;
//   onRequiredChange: (questionId: number, required: boolean) => void;
//   onDeleteQuestion: (id: number) => void;
// }

// const REPLY_TYPE_RATING = 4;
// const REPLY_TYPE_FILE_UPLOAD = 3;
// const REPLY_TYPE_TEXT = 5;

// const SelectedQuestions: React.FC<Props> = ({
//   selectedQuestions,
//   dependencyState,
//   onDependencyChange,
//   onRequiredChange,
//   onDeleteQuestion,
// }) => {
//   const [expandedIds, setExpandedIds] = useState<number[]>([]);

//   const toggleExpand = (id: number) => {
//     setExpandedIds((prev) =>
//       prev.includes(id) ? prev.filter((qId) => qId !== id) : [...prev, id]
//     );
//   };

//   return (
//     <Droppable droppableId="selected-questions">
//       {(provided, snapshot) => (
//         <div
//           ref={provided.innerRef}
//           {...provided.droppableProps}
//           className={`border-2 border-dashed rounded-2xl p-4 min-h-[340px] transition ${
//             snapshot.isDraggingOver
//               ? "border-[#EF5644] bg-[#EF5644]/5"
//               : "border-[#EF5644]/30 bg-[#EF5644]/[0.02]"
//           }`}
//         >
//           {selectedQuestions.length === 0 ? (
//             <div className="h-[300px] flex items-center justify-center text-gray-400 text-sm">
//               سوالات را اینجا رها کنید
//             </div>
//           ) : (
//             <div className="space-y-3">
//               {selectedQuestions.map((q, index) => {
//                 const isExpanded = expandedIds.includes(q.id);

//                 const currentState = dependencyState[q.id] || {
//                   parentQuestionId: 0,
//                   contentId: [],
//                   isRequired: false,
//                   selectedPoint: 0,
//                 };

//                 const availableParents = selectedQuestions.filter((item) => {
//                   if (item.id === q.id) return false;
//                   if (!item.isActive) return false;
//                   if (item.id === currentState.parentQuestionId) return true;
//                   const isUsedAsParentElsewhere = Object.entries(
//                     dependencyState
//                   ).some(
//                     ([questionId, state]) =>
//                       Number(questionId) !== q.id &&
//                       state.parentQuestionId === item.id
//                   );
//                   if (isUsedAsParentElsewhere) return false;
//                   return true;
//                 });

//                 const selectedParent = selectedQuestions.find(
//                   (p) => p.id === currentState.parentQuestionId
//                 );

//                 return (
//                   <Draggable
//                     key={q.id}
//                     draggableId={`selected-${q.id}`}
//                     index={index}
//                   >
//                     {(dragProvided, dragSnapshot) => (
//                       <div
//                         ref={dragProvided.innerRef}
//                         {...dragProvided.draggableProps}
//                         className={`bg-white rounded-2xl border border-gray-100 shadow-sm p-3 ${
//                           dragSnapshot.isDragging
//                             ? "shadow-lg border-[#EF5644]"
//                             : ""
//                         }`}
//                       >
//                         {/* Header کارت سوال */}
//                         <div className="flex items-center justify-between">
//                           <div
//                             {...dragProvided.dragHandleProps}
//                             className="text-gray-400 cursor-grab flex items-center gap-1 text-[10px]"
//                           >
//                             <FiMove /> {index + 1}
//                           </div>
//                           <button
//                             onClick={() => onDeleteQuestion(q.id)}
//                             className="text-gray-300 hover:text-red-500"
//                           >
//                             <FiTrash2 size={14} />
//                           </button>
//                         </div>

//                         <h4 className="mt-2 text-[12px] font-bold text-gray-800 line-clamp-1">
//                           {q.title}
//                         </h4>
//                         <div className="flex gap-2 my-2">
//                           <span className="text-[10px] px-2 py-0.5 rounded-full bg-[#EF5644]/10 text-[#EF5644]">
//                             {q.questionAssessmentMethod?.text}
//                           </span>
//                           <span className="text-[10px] px-2 py-0.5 rounded-full bg-blue-50 text-blue-600">
//                             {q.selectReplyType?.text}
//                           </span>
//                         </div>
//                         {/* دکمه‌های تنظیمات و اجباری */}
//                         <div className="mt-3 grid grid-cols-1 gap-2">
//                           <button
//                             type="button"
//                             onClick={() => toggleExpand(q.id)}
//                             className="bg-amber-50  text-gray-600 text-[11px] font-bold py-2  rounded-xl transition flex items-center justify-center gap-1"
//                           >
//                             تنظیمات{" "}
//                             <FiChevronDown
//                               className={isExpanded ? "rotate-180" : ""}
//                             />
//                           </button>
//                           {/* <label className="flex items-center justify-center gap-2 bg-amber-50 text-amber-700 text-[11px] font-bold py-2 rounded-xl cursor-pointer">
//                             <input
//                               type="checkbox"
//                               checked={currentState.isRequired}
//                               onChange={(e) =>
//                                 onRequiredChange(q.id, e.target.checked)
//                               }
//                               className="w-4 h-4 accent-[#EF5644]"
//                             />
//                             اجباری
//                           </label> */}
//                         </div>

//                         {/* پنل تنظیمات وابستگی */}
//                         {isExpanded && (
//                           <div className="mt-3 rounded-xl border border-[#EF5644]/20 bg-[#EF5644]/5 p-3">
//                             <label className="block text-[10px] font-bold text-gray-600 mb-1">
//                               سوال والد (وابستگی)
//                             </label>

//                             <select
//                               key={`select-q-${q.id}-parents-${availableParents.length}`}
//                               className="w-full text-[11px] p-2 rounded-lg border border-gray-200 bg-white"
//                               value={currentState.parentQuestionId}
//                               onChange={(e) => {
//                                 const val = Number(e.target.value);
//                                 onDependencyChange(q.id, val, [], 0);
//                               }}
//                             >
//                               <option value={0}>بدون وابستگی</option>
//                               {availableParents.map((ap) => (
//                                 <option key={ap.id} value={ap.id}>
//                                   {ap.title}
//                                 </option>
//                               ))}
//                             </select>

//                             {/* نمایش گزینه‌های سوال والد اگر انتخاب شده باشد */}
//                             {currentState.parentQuestionId > 0 &&
//                               selectedParent &&
//                               selectedParent.selectReplyType?.id !==
//                                 REPLY_TYPE_FILE_UPLOAD &&
//                               selectedParent.selectReplyType?.id !==
//                                 REPLY_TYPE_TEXT && (
//                                 <>
//                                   {/* سوالات بدون گزینه‌ی مشخص: آپلود فایل / متنی */}
//                                   {(selectedParent.selectReplyType?.id ===
//                                     REPLY_TYPE_FILE_UPLOAD ||
//                                     selectedParent.selectReplyType?.id ===
//                                       REPLY_TYPE_TEXT) && (
//                                     <div className="mt-3 flex items-center gap-2 bg-white border border-gray-100 rounded-lg p-2 animate-fadeIn">
//                                       {selectedParent.selectReplyType?.id ===
//                                       REPLY_TYPE_FILE_UPLOAD ? (
//                                         <FiFile
//                                           className="text-[#EF5644] shrink-0"
//                                           size={16}
//                                         />
//                                       ) : (
//                                         <FiType
//                                           className="text-[#EF5644] shrink-0"
//                                           size={16}
//                                         />
//                                       )}
//                                       <span className="text-[10px] text-gray-600 leading-4">
//                                         این نوع سوال گزینه‌ی مشخصی ندارد؛ با ثبت
//                                         هر پاسخی، سوال فرزند نمایش داده می‌شود.
//                                       </span>
//                                     </div>
//                                   )}

//                                   {/* سوالات درجه‌بندی (ستاره‌ای) */}
//                                   {selectedParent.selectReplyType?.id ===
//                                     REPLY_TYPE_RATING && (
//                                     <div className="mt-3 animate-fadeIn">
//                                       {(() => {
//                                         const maxStars =
//                                           Number(
//                                             selectedParent
//                                               .questionContentList?.[0]?.title
//                                           ) || 5;
//                                         const selectedPoint =
//                                           currentState.selectedPoint ?? 0;

//                                         return (
//                                           <>
//                                             <p className="text-[10px] font-bold text-gray-600 mb-2">
//                                               حداقل امتیاز محرک (از {maxStars}{" "}
//                                               ستاره)
//                                             </p>
//                                             <div className="flex items-center gap-1 flex-wrap">
//                                               {Array.from(
//                                                 { length: maxStars },
//                                                 (_, i) => i + 1
//                                               ).map((star) => {
//                                                 const filled =
//                                                   star <= selectedPoint;
//                                                 const StarIcon = filled
//                                                   ? AiFillStar
//                                                   : AiOutlineStar;

//                                                 return (
//                                                   <button
//                                                     key={star}
//                                                     type="button"
//                                                     onClick={() =>
//                                                       onDependencyChange(
//                                                         q.id,
//                                                         currentState.parentQuestionId,
//                                                         currentState.contentId,
//                                                         star
//                                                       )
//                                                     }
//                                                     className="text-[#EF5644] hover:scale-110 transition-transform"
//                                                     title={`${star} ستاره`}
//                                                   >
//                                                     <StarIcon size={18} />
//                                                   </button>
//                                                 );
//                                               })}

//                                               {selectedPoint > 0 && (
//                                                 <span className="text-[10px] text-gray-500 mr-2">
//                                                   ({selectedPoint} ستاره یا
//                                                   بیشتر)
//                                                 </span>
//                                               )}
//                                             </div>
//                                           </>
//                                         );
//                                       })()}
//                                     </div>
//                                   )}

//                                   {/* سوالات چندگزینه‌ای / تک‌انتخابی / بله‌خیر: همان منطق قبلی */}
//                                   {selectedParent.selectReplyType?.id !==
//                                     REPLY_TYPE_FILE_UPLOAD &&
//                                     selectedParent.selectReplyType?.id !==
//                                       REPLY_TYPE_TEXT &&
//                                     selectedParent.selectReplyType?.id !==
//                                       REPLY_TYPE_RATING && (
//                                       <div className="mt-3 animate-fadeIn">
//                                         <p className="text-[10px] font-bold text-gray-600 mb-2">
//                                           گزینه محرک:
//                                         </p>
//                                         <div className="flex flex-wrap gap-2">
//                                           {selectedParent.questionContentList.map(
//                                             (opt) => {
//                                               const isMulti =
//                                                 selectedParent.selectReplyType
//                                                   ?.id === 1;
//                                               const isChecked =
//                                                 currentState.contentId.includes(
//                                                   opt.id
//                                                 );

//                                               return (
//                                                 <label
//                                                   key={opt.id}
//                                                   className="flex items-center gap-1 bg-white border border-gray-100 px-2 py-1 rounded-lg cursor-pointer"
//                                                 >
//                                                   <input
//                                                     type={
//                                                       isMulti
//                                                         ? "checkbox"
//                                                         : "radio"
//                                                     }
//                                                     name={`dep-${q.id}`}
//                                                     checked={isChecked}
//                                                     onChange={() => {
//                                                       let newIds = [];
//                                                       if (isMulti) {
//                                                         newIds = isChecked
//                                                           ? currentState.contentId.filter(
//                                                               (id) =>
//                                                                 id !== opt.id
//                                                             )
//                                                           : [
//                                                               ...currentState.contentId,
//                                                               opt.id,
//                                                             ];
//                                                       } else {
//                                                         newIds = [opt.id];
//                                                       }
//                                                       onDependencyChange(
//                                                         q.id,
//                                                         currentState.parentQuestionId,
//                                                         newIds
//                                                       );
//                                                     }}
//                                                     className="w-3 h-3 accent-[#EF5644]"
//                                                   />
//                                                   <span className="text-[10px] text-gray-700">
//                                                     {opt.title}
//                                                   </span>
//                                                 </label>
//                                               );
//                                             }
//                                           )}
//                                         </div>
//                                       </div>
//                                     )}
//                                 </>
//                               )}
//                           </div>
//                         )}
//                       </div>
//                     )}
//                   </Draggable>
//                 );
//               })}
//             </div>
//           )}
//           {provided.placeholder}
//         </div>
//       )}
//     </Droppable>
//   );
// };

// export default SelectedQuestions;


import React, { useState } from "react";
import { Droppable, Draggable } from "@hello-pangea/dnd";
import {
  FiTrash2,
  FiChevronDown,
  FiMove,
  FiFile,
  FiType,
} from "react-icons/fi";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";

interface QuestionContent {
  id: number;
  priority: number;
  title: string;
}

interface Question {
  id: number;
  title: string;
  isActive: boolean;
  questionContentList: QuestionContent[];
  selectReplyType: { id: number; text: string };
  questionType: { id: number; text: string };
  questionAssessmentMethod: { id: number; text: string };
  validFrom: any;
  validTo: any;
  createdDate: any;
  modifiedDate: any;
  creator: string | null;
  modifier: string;
}

interface DependencyState {
  parentQuestionId: number;
  contentId: number[];
  isRequired: boolean;
  // فقط وقتی سوال والد از نوع «درجه‌بندی» (ستاره‌ای) باشد استفاده می‌شود
  selectedPoint?: number;
}

interface Props {
  selectedQuestions: Question[];
  dependencyState: Record<number, DependencyState>;
  onDependencyChange: (
    questionId: number,
    parentQuestionId: number,
    contentId: number[],
    selectedPoint?: number
  ) => void;
  onRequiredChange: (questionId: number, required: boolean) => void;
  onDeleteQuestion: (id: number) => void;
}

const REPLY_TYPE_RATING = 4;
const REPLY_TYPE_FILE_UPLOAD = 3;
const REPLY_TYPE_TEXT = 5;

const SelectedQuestions: React.FC<Props> = ({
  selectedQuestions,
  dependencyState,
  onDependencyChange,
  onRequiredChange,
  onDeleteQuestion,
}) => {
  const [expandedIds, setExpandedIds] = useState<number[]>([]);

  const toggleExpand = (id: number) => {
    setExpandedIds((prev) =>
      prev.includes(id) ? prev.filter((qId) => qId !== id) : [...prev, id]
    );
  };

  /**
   * بررسی می‌کند که آیا انتخاب `candidateParentId` به‌عنوان والدِ
   * `currentQuestionId` باعث ایجاد یک چرخه (cycle) می‌شود یا نه.
   *
   * برای این کار، از candidateParentId به سمت بالا (والدِ والد، والدِ
   * والدِ والد و ...) حرکت می‌کنیم؛ اگر در این مسیر به خودِ
   * currentQuestionId برسیم، یعنی candidateParentId از قبل (مستقیم یا
   * غیرمستقیم) به currentQuestionId وابسته است و انتخابش به‌عنوان والد
   * باعث می‌شود currentQuestionId هم به خودش وابسته شود (چرخه).
   *
   * مثال: اگر A هم‌اکنون فرزندِ B باشد (A.parentQuestionId = B)، این تابع
   * جلوی انتخاب A به‌عنوان والدِ B را می‌گیرد، چون مسیر از A به بالا
   * مستقیماً به B می‌رسد.
   */
  const wouldCreateCycle = (
    candidateParentId: number,
    currentQuestionId: number
  ): boolean => {
    let cursor = candidateParentId;
    const visited = new Set<number>();

    while (cursor && cursor !== 0) {
      if (cursor === currentQuestionId) return true;
      if (visited.has(cursor)) break; // محافظت در برابر چرخه‌ی از‌قبل‌موجود در داده
      visited.add(cursor);
      cursor = dependencyState[cursor]?.parentQuestionId || 0;
    }

    return false;
  };

  return (
    <Droppable droppableId="selected-questions">
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          className={`border-2 border-dashed rounded-2xl p-4 min-h-[340px] transition ${
            snapshot.isDraggingOver
              ? "border-[#EF5644] bg-[#EF5644]/5"
              : "border-[#EF5644]/30 bg-[#EF5644]/[0.02]"
          }`}
        >
          {selectedQuestions.length === 0 ? (
            <div className="h-[300px] flex items-center justify-center text-gray-400 text-sm">
              سوالات را اینجا رها کنید
            </div>
          ) : (
            <div className="space-y-3">
              {selectedQuestions.map((q, index) => {
                const isExpanded = expandedIds.includes(q.id);

                const currentState = dependencyState[q.id] || {
                  parentQuestionId: 0,
                  contentId: [],
                  isRequired: false,
                  selectedPoint: 0,
                };

                const availableParents = selectedQuestions.filter((item) => {
                  if (item.id === q.id) return false;
                  if (!item.isActive) return false;
                  if (item.id === currentState.parentQuestionId) return true;

                  const isUsedAsParentElsewhere = Object.entries(
                    dependencyState
                  ).some(
                    ([questionId, state]) =>
                      Number(questionId) !== q.id &&
                      state.parentQuestionId === item.id
                  );
                  if (isUsedAsParentElsewhere) return false;

                  // جلوگیری از چرخه: اگر item از قبل (مستقیم یا غیرمستقیم)
                  // به q وابسته باشد، انتخابش به‌عنوان والدِ q مجاز نیست
                  if (wouldCreateCycle(item.id, q.id)) return false;

                  return true;
                });

                const selectedParent = selectedQuestions.find(
                  (p) => p.id === currentState.parentQuestionId
                );

                return (
                  <Draggable
                    key={q.id}
                    draggableId={`selected-${q.id}`}
                    index={index}
                  >
                    {(dragProvided, dragSnapshot) => (
                      <div
                        ref={dragProvided.innerRef}
                        {...dragProvided.draggableProps}
                        className={`bg-white rounded-2xl border border-gray-100 shadow-sm p-3 ${
                          dragSnapshot.isDragging
                            ? "shadow-lg border-[#EF5644]"
                            : ""
                        }`}
                      >
                        {/* Header کارت سوال */}
                        <div className="flex items-center justify-between">
                          <div
                            {...dragProvided.dragHandleProps}
                            className="text-gray-400 cursor-grab flex items-center gap-1 text-[10px]"
                          >
                            <FiMove /> {index + 1}
                          </div>
                          <button
                            onClick={() => onDeleteQuestion(q.id)}
                            className="text-gray-300 hover:text-red-500"
                          >
                            <FiTrash2 size={14} />
                          </button>
                        </div>

                        <h4 className="mt-2 text-[12px] font-bold text-gray-800 line-clamp-1">
                          {q.title}
                        </h4>
                        <div className="flex gap-2 my-2">
                          <span className="text-[10px] px-2 py-0.5 rounded-full bg-[#EF5644]/10 text-[#EF5644]">
                            {q.questionAssessmentMethod?.text}
                          </span>
                          <span className="text-[10px] px-2 py-0.5 rounded-full bg-blue-50 text-blue-600">
                            {q.selectReplyType?.text}
                          </span>
                        </div>
                        {/* دکمه‌های تنظیمات و اجباری */}
                        <div className="mt-3 grid grid-cols-1 gap-2">
                          <button
                            type="button"
                            onClick={() => toggleExpand(q.id)}
                            className="bg-amber-50  text-gray-600 text-[11px] font-bold py-2  rounded-xl transition flex items-center justify-center gap-1"
                          >
                            تنظیمات{" "}
                            <FiChevronDown
                              className={isExpanded ? "rotate-180" : ""}
                            />
                          </button>
                          {/* <label className="flex items-center justify-center gap-2 bg-amber-50 text-amber-700 text-[11px] font-bold py-2 rounded-xl cursor-pointer">
                            <input
                              type="checkbox"
                              checked={currentState.isRequired}
                              onChange={(e) =>
                                onRequiredChange(q.id, e.target.checked)
                              }
                              className="w-4 h-4 accent-[#EF5644]"
                            />
                            اجباری
                          </label> */}
                        </div>

                        {/* پنل تنظیمات وابستگی */}
                        {isExpanded && (
                          <div className="mt-3 rounded-xl border border-[#EF5644]/20 bg-[#EF5644]/5 p-3">
                            <label className="block text-[10px] font-bold text-gray-600 mb-1">
                              سوال والد (وابستگی)
                            </label>

                            <select
                              key={`select-q-${q.id}-parents-${availableParents.length}`}
                              className="w-full text-[11px] p-2 rounded-lg border border-gray-200 bg-white"
                              value={currentState.parentQuestionId}
                              onChange={(e) => {
                                const val = Number(e.target.value);
                                onDependencyChange(q.id, val, [], 0);
                              }}
                            >
                              <option value={0}>بدون وابستگی</option>
                              {availableParents.map((ap) => (
                                <option key={ap.id} value={ap.id}>
                                  {ap.title}
                                </option>
                              ))}
                            </select>

                            {/* نمایش گزینه‌های سوال والد اگر انتخاب شده باشد */}
                            {currentState.parentQuestionId > 0 &&
                              selectedParent &&
                              selectedParent.selectReplyType?.id !==
                                REPLY_TYPE_FILE_UPLOAD &&
                              selectedParent.selectReplyType?.id !==
                                REPLY_TYPE_TEXT && (
                                <>
                                  {/* سوالات بدون گزینه‌ی مشخص: آپلود فایل / متنی */}
                                  {(selectedParent.selectReplyType?.id ===
                                    REPLY_TYPE_FILE_UPLOAD ||
                                    selectedParent.selectReplyType?.id ===
                                      REPLY_TYPE_TEXT) && (
                                    <div className="mt-3 flex items-center gap-2 bg-white border border-gray-100 rounded-lg p-2 animate-fadeIn">
                                      {selectedParent.selectReplyType?.id ===
                                      REPLY_TYPE_FILE_UPLOAD ? (
                                        <FiFile
                                          className="text-[#EF5644] shrink-0"
                                          size={16}
                                        />
                                      ) : (
                                        <FiType
                                          className="text-[#EF5644] shrink-0"
                                          size={16}
                                        />
                                      )}
                                      <span className="text-[10px] text-gray-600 leading-4">
                                        این نوع سوال گزینه‌ی مشخصی ندارد؛ با ثبت
                                        هر پاسخی، سوال فرزند نمایش داده می‌شود.
                                      </span>
                                    </div>
                                  )}

                                  {/* سوالات درجه‌بندی (ستاره‌ای) */}
                                  {selectedParent.selectReplyType?.id ===
                                    REPLY_TYPE_RATING && (
                                    <div className="mt-3 animate-fadeIn">
                                      {(() => {
                                        const maxStars =
                                          Number(
                                            selectedParent
                                              .questionContentList?.[0]?.title
                                          ) || 5;
                                        const selectedPoint =
                                          currentState.selectedPoint ?? 0;

                                        return (
                                          <>
                                            <p className="text-[10px] font-bold text-gray-600 mb-2">
                                              حداقل امتیاز محرک (از {maxStars}{" "}
                                              ستاره)
                                            </p>
                                            <div className="flex items-center gap-1 flex-wrap">
                                              {Array.from(
                                                { length: maxStars },
                                                (_, i) => i + 1
                                              ).map((star) => {
                                                const filled =
                                                  star <= selectedPoint;
                                                const StarIcon = filled
                                                  ? AiFillStar
                                                  : AiOutlineStar;

                                                return (
                                                  <button
                                                    key={star}
                                                    type="button"
                                                    onClick={() =>
                                                      onDependencyChange(
                                                        q.id,
                                                        currentState.parentQuestionId,
                                                        currentState.contentId,
                                                        star
                                                      )
                                                    }
                                                    className="text-[#EF5644] hover:scale-110 transition-transform"
                                                    title={`${star} ستاره`}
                                                  >
                                                    <StarIcon size={18} />
                                                  </button>
                                                );
                                              })}

                                              {selectedPoint > 0 && (
                                                <span className="text-[10px] text-gray-500 mr-2">
                                                  ({selectedPoint} ستاره یا
                                                  بیشتر)
                                                </span>
                                              )}
                                            </div>
                                          </>
                                        );
                                      })()}
                                    </div>
                                  )}

                                  {/* سوالات چندگزینه‌ای / تک‌انتخابی / بله‌خیر: همان منطق قبلی */}
                                  {selectedParent.selectReplyType?.id !==
                                    REPLY_TYPE_FILE_UPLOAD &&
                                    selectedParent.selectReplyType?.id !==
                                      REPLY_TYPE_TEXT &&
                                    selectedParent.selectReplyType?.id !==
                                      REPLY_TYPE_RATING && (
                                      <div className="mt-3 animate-fadeIn">
                                        <p className="text-[10px] font-bold text-gray-600 mb-2">
                                          گزینه محرک:
                                        </p>
                                        <div className="flex flex-wrap gap-2">
                                          {selectedParent.questionContentList.map(
                                            (opt) => {
                                              const isMulti =
                                                selectedParent.selectReplyType
                                                  ?.id === 1;
                                              const isChecked =
                                                currentState.contentId.includes(
                                                  opt.id
                                                );

                                              return (
                                                <label
                                                  key={opt.id}
                                                  className="flex items-center gap-1 bg-white border border-gray-100 px-2 py-1 rounded-lg cursor-pointer"
                                                >
                                                  <input
                                                    type={
                                                      isMulti
                                                        ? "checkbox"
                                                        : "radio"
                                                    }
                                                    name={`dep-${q.id}`}
                                                    checked={isChecked}
                                                    onChange={() => {
                                                      let newIds = [];
                                                      if (isMulti) {
                                                        newIds = isChecked
                                                          ? currentState.contentId.filter(
                                                              (id) =>
                                                                id !== opt.id
                                                            )
                                                          : [
                                                              ...currentState.contentId,
                                                              opt.id,
                                                            ];
                                                      } else {
                                                        newIds = [opt.id];
                                                      }
                                                      onDependencyChange(
                                                        q.id,
                                                        currentState.parentQuestionId,
                                                        newIds
                                                      );
                                                    }}
                                                    className="w-3 h-3 accent-[#EF5644]"
                                                  />
                                                  <span className="text-[10px] text-gray-700">
                                                    {opt.title}
                                                  </span>
                                                </label>
                                              );
                                            }
                                          )}
                                        </div>
                                      </div>
                                    )}
                                </>
                              )}
                          </div>
                        )}
                      </div>
                    )}
                  </Draggable>
                );
              })}
            </div>
          )}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default SelectedQuestions;
